// Common-sense gender defaults per sub-category.
// Used both in the Admin form (auto-suggest when creating/editing a design)
// and in every gender filter (StylePage, CategoryPage) so that legacy default
// catalog entries — which have no explicit `gender` field — are grouped
// intelligently instead of all defaulting to "unisex".
//
// The overrides are conservative: things that are almost exclusively worn by
// one segment (jhumkas, mangalsutra, tops, bangles) map to that segment;
// anything ambiguous (rings, chains, pendants) stays unisex.

const SUB_DEFAULTS = {
  // Ladies-first pieces
  jhumkas: "ladies",
  earrings: "ladies",
  tops: "ladies",
  bangles: "ladies",
  mangalsutra: "ladies",
  necklaces: "ladies",
  temple: "ladies",
  antique: "ladies",
  // Unisex
  rings: "unisex",
  chains: "unisex",
  pendants: "unisex",
  coins: "unisex",
  murti: "unisex",
  bracelets: "unisex",
};

/**
 * Returns the sensible default gender for a sub-category.
 * Falls back to "unisex" when the sub isn't in the map.
 */
export function defaultGenderFor(subSlug) {
  if (!subSlug) return "unisex";
  return SUB_DEFAULTS[subSlug] || "unisex";
}

/**
 * Resolves the effective gender of a design.
 * - If the design has an explicit gender (Admin picked one), use it.
 * - Otherwise fall back to the sub-category default.
 * - Otherwise "unisex".
 */
export function genderOf(design) {
  if (!design) return "unisex";
  if (design.gender) return design.gender;
  const sub =
    (design.subCategory && design.subCategory.slug) ||
    design.subCategory ||
    "";
  return defaultGenderFor(sub);
}

export const GENDER_LABELS = {
  ladies: "Ladies",
  men: "Men",
  unisex: "Unisex",
  kids: "Kids",
};
